import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectUserData, selectUserInfo } from "../store/selectors";
import {
  clearAnalyticsUser,
  identifyAnalyticsUser,
  initAnalytics,
  trackPageView,
} from "./index";

export const AnalyticsObserver = () => {
  const location = useLocation();
  const user = useSelector(selectUserInfo);
  const userData = useSelector(selectUserData);
  const previousUrlRef = useRef<string>();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (user?.id !== undefined && user?.id !== null) {
      identifyAnalyticsUser(user, userData);
      return;
    }

    clearAnalyticsUser();
  }, [user, userData]);

  useEffect(() => {
    const url = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(url, {
      title: document.title,
      referer: previousUrlRef.current,
    });
    previousUrlRef.current = `${window.location.origin}${url}`;
  }, [location.hash, location.pathname, location.search]);

  return null;
};
